
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demos/anthropic",
      function () {
        return require("private-next-pages/demos/anthropic.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demos/anthropic"])
      });
    }
  